'use client'
import { UseQueryResult, useQuery } from '@tanstack/react-query'
import services from '../services'
import { apiResponseHandler, queryKeys } from '@/shared/api/react-query'
import { projectMappers, Project } from '../../lib'

const useHook = () => {
  const queryKey = [queryKeys((a, m, p) => a.project.getProjects + m.get)]
  const query = useQuery({
    queryKey,
    queryFn: async () => apiResponseHandler(await services.get()),
  })

  return {
    ...query,
    data: projectMappers.mapProjects(query?.data || []),
    queryKey,
  } as unknown as UseQueryResult<Project[]> & { queryKey: typeof queryKey }
}
export default useHook
